import {FilteringFlow} from "@filtering.js/filtering.js/ui"

export default (el) => {
  class Variant extends FilteringFlow {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    updatePrice(items) {
      for (let item of items) {
        let element = item.data.element
        let regularPriceValue = element.getAttribute('data-price-regular_price')
        let salePriceValue = element.getAttribute('data-price-sale_price')
        let percentPriceValue = element.getAttribute('data-price-percent')
        let unitValue = element.getAttribute('data-unit')
        let variationValue = element.getAttribute('data-variation-name')

        el.querySelector('.js-price-percent').innerHTML = '-' + percentPriceValue + '%'
        el.querySelector('.js-price-regular').innerHTML = this.numberWithCommas(regularPriceValue) + 'đ'
        el.querySelector('.js-price-sale').innerHTML = this.numberWithCommas(salePriceValue) + 'đ'

        // Update from
        document.querySelector('.mp-modal-order-total').innerHTML = this.numberWithCommas(salePriceValue) + 'đ'
        document.querySelector('.mp-info-order-total').innerHTML = this.numberWithCommas(salePriceValue) + 'đ'

        document.querySelector('.mp-form-price').value = salePriceValue
        document.querySelector('.mp-form-total').value = salePriceValue
        document.querySelector('.mp-form-variation').value = variationValue

        if (unitValue) {
          el.querySelector('.js-unit').innerHTML = unitValue
        }
      }
    }

    handleFilterResult(result) {
      super.handleFilterResult(result)
      let items = result.filteredItems
      let variant = items[0].data.element
      let variantId = variant.id
      let productId = variant.getAttribute('data-product-id')
      // console.log(variantId)

      this.updatePrice(items)

      // Default first options
      document.querySelectorAll('.filtering-group').forEach(function (el) {
        el.querySelectorAll('.filtering-filter').forEach(function (i) {
          if (i.classList.contains('checked')) {
            i.classList.add('pe-none')
          }
          else {
            i.classList.remove('pe-none')
          }
        })
      })

      // Trigger
      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
          action: 'variation',
          id: productId,
          variation: variantId,
        },
        success: function (res) {
          $(document).trigger('variation_trigger', [res.data]);
        },
        error: function (err) {
          console.error(err);
        }
      })
    }
  }

  new Variant(document.querySelector('#variant'))
}
